import { createAction } from '@src/redux/helpers/createAction';
import {
  CLEAR_REGISTRATION_DATA,
  SEARCH_REGISTRATION_STATUS,
} from './constants';
import { registrationStatus } from './requests';

export const searchRegistrationStatus = (query, onSuccess, onError) => {
  return createAction({
    type: SEARCH_REGISTRATION_STATUS,
    cache: false,
    payload: query,
    meta: {
      onSuccess,
      onError,
      async: registrationStatus,
    },
  });
};

export const clearTinRegistration = () => {
  return {
    type: CLEAR_REGISTRATION_DATA,
  };
};
